import { makeStyles } from '@material-ui/core/styles';
import { isDarkTheme } from 'UI/theme/darkTones';

/**
 * Priority chip colors. Light keeps its original pastel chips; dark uses the palette's dark tint
 * (`FP100`) with its light shade as text, so the chip does not glow on dark panels.
 * @param {Object} theme MUI theme
 * @param {string} paletteKey palette color for the dark tone (`success`, `primary`, `error`)
 * @param {{ backgroundColor: string, border: string, color: string }} light original light colors
 */
const priorityChipColors = (theme, paletteKey, light) =>
  isDarkTheme(theme)
    ? {
        backgroundColor: theme.palette[paletteKey].FP100,
        border: light.border,
        color: theme.palette[paletteKey].light
      }
    : light;

export const useSelectedItemChipStyles = makeStyles(theme => ({
  chipContainer: {
    position: 'relative',
    display: 'inline-block',
    maxWidth: '100%'
  },
  itemChip: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 20,
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.25),
    position: 'relative',
    overflow: 'hidden',
    willChange: 'transform, box-shadow',
    transition: 'transform 0.15s ease-out, box-shadow 0.15s ease-out',
    width: '100%',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      '& $chipContent': {
        maxWidth: 'calc(100% - 48px)'
      },
      '& $chipActions': {
        opacity: 1
      }
    },
    '&.popover-open': {
      '& $chipContent': {
        maxWidth: 'calc(100% - 48px)'
      }
    },
    '&.must-have': priorityChipColors(theme, 'success', {
      backgroundColor: '#E8F5E8',
      border: '1px solid #4CAF50',
      color: '#2E7D32'
    }),
    '&.can-have': priorityChipColors(theme, 'primary', {
      backgroundColor: '#E3F2FD',
      border: '1px solid #2196F3',
      color: '#1565C0'
    }),
    '&.doesnt-have': priorityChipColors(theme, 'error', {
      backgroundColor: '#FFEBEE',
      border: '1px solid #F44336',
      color: '#C62828'
    })
  },
  chipContent: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
    transition: 'max-width 0.15s ease-out',
    '& > :last-child': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  chipActions: {
    position: 'absolute',
    right: theme.spacing(0.25),
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    opacity: 0,
    transition: 'opacity 0.15s ease-out',
    backgroundColor: 'inherit',
    borderRadius: 10,
    '&.popover-open': {
      opacity: 1
    }
  },
  actionButton: {
    padding: 0
  },
  priorityText: {
    marginRight: theme.spacing(0.5)
  },
  itemText: {
    marginRight: theme.spacing(0.5)
  }
}));
